import { Stack } from "@mui/material";
import { m } from "framer-motion";
import { useContext } from "react";
import useResponsive from "src/hooks/useResponsive";

import Context from "../../context";
import TransferPositionsHeader from "../FundsSelection/components/TransferPositionsHeader";
import useGetPositionsSelected from "./hooks/useGetPositionsSelected";
import RevisionList from "./RevisionList";
import RevisiónRowBtn from "./TransferRowBtn";

// ----------------------------------------------------------------------

export const RevisionStep = () => {
	const { actions } = useContext(Context);
	const { positionsSelected } = useGetPositionsSelected();

	const isMobile = useResponsive("down", "sm");
	const isDownMd = useResponsive("down", "md");

	const onPressBack = () => {
		actions.setStep(4);
	};

	return (
		<Stack
			component={m.div}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 1 }}
			width={isDownMd ? "auto" : 800}
			height={isMobile ? "auto" : 500}
		>
			<TransferPositionsHeader onPressBack={onPressBack} />
			<RevisiónRowBtn />
			<RevisionList data={positionsSelected} />
		</Stack>
	);
};

export default RevisionStep;
